import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import IconButton from "../buttons/IconButton";

interface DialogHeaderProps {
  title: string;
  /** The title's element ID, so a dialog can name itself by it (`aria-labelledby`). */
  titleId?: string;
  subtitle?: string;
  /** The subtitle's element ID, so a dialog can be described by it (`aria-describedby`). */
  subtitleId?: string;
  onClose: () => void;
  closeDisabled?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

export default function DialogHeader({
  title,
  titleId,
  subtitle,
  subtitleId,
  onClose,
  closeDisabled = false,
  actions,
  className = "",
}: DialogHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className={`app-modal-header flex items-center justify-between px-6 py-4 ${className}`}>
      <div>
        <h2 id={titleId} className="app-modal-title text-xl font-semibold">{title}</h2>
        {subtitle ? <p id={subtitleId} className="app-modal-subtitle text-sm">{subtitle}</p> : null}
      </div>
      <div className="ml-4 flex items-center gap-2">
        {actions}
        <IconButton type="button" onClick={onClose} disabled={closeDisabled} label={t("common.close")}>
          <XMarkIcon className="h-6 w-6" />
        </IconButton>
      </div>
    </div>
  );
}
